import React from 'react'
import { useHistory } from 'react-router-dom'

import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { Col, Row } from 'react-bootstrap'
import { MENU_OPTIONS } from '../../../layout/Layout/menu-options'
import { useSelector } from 'react-redux'
import { getMenuListSelector } from '../../../selectors'
import MenuCard from '../../../layout/Navigation/menu-card'

//const menuDetails =  MENU_OPTIONS.filter((ele) => ele.key === 'OTHER_SERVICES')[0].children
const subMenuDetails = MENU_OPTIONS.filter((ele) => ele.key === 'REQUESTS')[0].children
const subChildrenMenuDetails = subMenuDetails.filter((ele) => ele.key === 'CHEQUE')[0].children

export default function Cheque() {
  const history = useHistory()
  const menuConfig = useSelector(getMenuListSelector)['CHEQUE'] || {}

  return (
    <LayoutWithAccountCard breadCumKey={'REQUEST_CHEQUE'}>
      {/* <div className='row'>
        <div className='col-7 d-flex'>
          <div>
            <img src={menuDetails.icon} alt='statement icon' />
          </div>
          <div>
            <span className='font-weight-bold'>{menuDetails.title}</span>
            <span className='header-title-section'>
              <p>{menuDetails.desc}</p>
            </span>
          </div>
        </div>
        <div className='col-5 text-right'></div>
      </div> */}

      <Row>
      {Object.keys(menuConfig).length>0 && subChildrenMenuDetails.map((option, index) => (
              <>
                {menuConfig[option.key] &&
            <MenuCard
              handleMenuCallback={() => history.push(option.link)}
              icon={option.icon}
              name={option.title}
              description={option.desc}
              key={index}
            />
                }
              </>
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
